function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="40" height="40" viewBox="0 0 40 40" {...props}><path d="M26.5 17c.83 0 1.5.67 1.5 1.5v8c0 .83-.67 1.5-1.5 1.5h-13a1.5 1.5 0 0 1-1.5-1.5v-8c0-.83.67-1.5 1.5-1.5h13zm.5 9.5v-8a.5.5 0 0 0-.5-.5h-13a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5zM13.5 16a.5.5 0 0 1 0-1h13a.5.5 0 0 1 0 1h-13zm1.5-2a.5.5 0 0 1 0-1h10a.5.5 0 0 1 0 1H15zm0 10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 0 1H15zm5.5 1a.5.5 0 0 1 0 1H15a.5.5 0 1 1 0-1h5.5zm4.5-6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2zm-2 3h2v-2h-2v2z" /></svg>;
});


// WEBPACK FOOTER //
// ./media/svg/mail-setup.svg